import { getAssetUrl } from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils';

// This needs to be in sync with app/static/font/_fonts.scss
export const fontFace = (): string =>
    `
    /* Normal */
    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 400;
        font-style: normal;
        src: url(${getAssetUrl('static/font/TT_Norms_Pro_Normal-latin.woff2')}) format('woff2');
        src: url('static/font/TT_Norms_Pro_Normal-latin.woff2') format('woff2');
        unicode-range: U+0000-00FF;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 400;
        font-style: normal;
        src: url(${getAssetUrl(
            'static/font/TT_Norms_Pro_Normal-latin-extended-a.woff2',
        )})' format('woff2');
        unicode-range: U+0100-017F;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 400;
        font-style: normal;
        src: url(${getAssetUrl(
            'static/font/TT_Norms_Pro_Normal-latin-extended-b.woff2',
        )})' format('woff2');
        unicode-range: U+0180-024F;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 400;
        font-style: normal;
        src: url(${getAssetUrl(
            'static/font/TT_Norms_Pro_Normal-latin-extended-additional.woff2',
        )})' format('woff2');
        unicode-range: U+1E00-1EFF;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 400;
        font-style: normal;
        src: url(${getAssetUrl('static/font/TT_Norms_Pro_Normal-rest.woff2')}) format('woff2');
        unicode-range: U+0259-03C0, U+2000-FB02;
    }

    /* Medium */
    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 500;
        font-style: normal;
        src: url(${getAssetUrl('static/font/TT_Norms_Pro_Medium-latin.woff2')}) format('woff2');
        unicode-range: U+0000-00FF;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 500;
        font-style: normal;
        src: url(${getAssetUrl(
            'static/font/TT_Norms_Pro_Medium-latin-extended-a.woff2',
        )})' format('woff2');
        unicode-range: U+0100-017F;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 500;
        font-style: normal;
        src: url(${getAssetUrl(
            'static/font/TT_Norms_Pro_Medium-latin-extended-b.woff2',
        )})' format('woff2');
        unicode-range: U+0180-024F;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 500;
        font-style: normal;
        src: url(${getAssetUrl(
            'static/font/TT_Norms_Pro_Medium-latin-extended-additional.woff2',
        )})' format('woff2');
        unicode-range: U+1E00-1EFF;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 500;
        font-style: normal;
        src: url(${getAssetUrl('static/font/TT_Norms_Pro_Medium-rest.woff2')}) format('woff2');
        unicode-range: U+0259-03C0, U+2000-FB02;
    }

    /* DemiBold */
    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 600;
        font-style: normal;
        src: url(${getAssetUrl('static/font/TT_Norms_Pro_DemiBold-latin.woff2')}) format('woff2');
        unicode-range: U+0000-00FF;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 600;
        font-style: normal;
        src: url(${getAssetUrl(
            'static/font/TT_Norms_Pro_DemiBold-latin-extended-a.woff2',
        )})' format('woff2');
        unicode-range: U+0100-017F;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 600;
        font-style: normal;
        src: url(${getAssetUrl(
            'static/font/TT_Norms_Pro_DemiBold-latin-extended-b.woff2',
        )})' format('woff2');
        unicode-range: U+0180-024F;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 600;
        font-style: normal;
        src: url(${getAssetUrl(
            'static/font/TT_Norms_Pro_DemiBold-latin-extended-additional.woff2',
        )})' format('woff2');
        unicode-range: U+1E00-1EFF;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 600;
        font-style: normal;
        src: url(${getAssetUrl('static/font/TT_Norms_Pro_DemiBold-rest.woff2')}) format('woff2');
        unicode-range: U+0259-03C0, U+2000-FB02;
    }

    /* Bold */
    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 700;
        font-style: normal;
        src: url(${getAssetUrl('static/font/TT_Norms_Pro_Bold-latin.woff2')}) format('woff2');
        unicode-range: U+0000-00FF;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 700;
        font-style: normal;
        src: url(${getAssetUrl(
            'static/font/TT_Norms_Pro_Bold-latin-extended-a.woff2',
        )})' format('woff2');
        unicode-range: U+0100-017F;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 700;
        font-style: normal;
        src: url(${getAssetUrl(
            'static/font/TT_Norms_Pro_Bold-latin-extended-b.woff2',
        )})' format('woff2');
        unicode-range: U+0180-024F;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 700;
        font-style: normal;
        src: url(${getAssetUrl(
            'static/font/TT_Norms_Pro_Bold-latin-extended-additional.woff2',
        )})' format('woff2');
        unicode-range: U+1E00-1EFF;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 700;
        font-style: normal;
        src: url(${getAssetUrl('static/font/TT_Norms_Pro_Bold-rest.woff2')}) format('woff2');
        unicode-range: U+0259-03C0, U+2000-FB02;
    }

    /* Place the English subset last */
    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 700;
        font-style: normal;
        src: url(${getAssetUrl('static/font/TT_Norms_Pro_Bold-english.woff2')}) format('woff2');
        unicode-range: U+0000-00A0, U+00A2-00A9, U+00AC-00AE, U+00B0-00B7, U+00B9-00BA, U+00BC-00BE,
            U+00D7, U+00F7, U+2000-206F, U+2074, U+20AC, U+2122, U+2190-21BB, U+2212, U+2215, U+F8FF,
            U+FEFF, U+FFFD;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 600;
        font-style: normal;
        src: url(${getAssetUrl(
            'static/font/TT_Norms_Pro_DemiBold-english.woff2',
        )})' format('woff2');
        unicode-range: U+0000-00A0, U+00A2-00A9, U+00AC-00AE, U+00B0-00B7, U+00B9-00BA, U+00BC-00BE,
            U+00D7, U+00F7, U+2000-206F, U+2074, U+20AC, U+2122, U+2190-21BB, U+2212, U+2215, U+F8FF,
            U+FEFF, U+FFFD;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 500;
        font-style: normal;
        src: url(${getAssetUrl('static/font/TT_Norms_Pro_Medium-english.woff2')}) format('woff2');
        unicode-range: U+0000-00A0, U+00A2-00A9, U+00AC-00AE, U+00B0-00B7, U+00B9-00BA, U+00BC-00BE,
            U+00D7, U+00F7, U+2000-206F, U+2074, U+20AC, U+2122, U+2190-21BB, U+2212, U+2215, U+F8FF,
            U+FEFF, U+FFFD;
    }

    @font-face {
        font-family: 'TT Norms Pro';
        font-display: swap;
        font-weight: 400;
        font-style: normal;
        src: url(${getAssetUrl('static/font/TT_Norms_Pro_Normal-english.woff2')}) format('woff2');
        unicode-range: U+0000-00A0, U+00A2-00A9, U+00AC-00AE, U+00B0-00B7, U+00B9-00BA, U+00BC-00BE,
            U+00D7, U+00F7, U+2000-206F, U+2074, U+20AC, U+2122, U+2190-21BB, U+2212, U+2215, U+F8FF,
            U+FEFF, U+FFFD;
    }
`;
